<template>
  <b-overlay
    :show="busy"
    spinner-type="grow"
    spinner-variant="primary"
    rounded="sm"
  >
    <b-card class="mt-2 mx-0 border-none p-0 tiles">
      <b-card-header
        id="orderplaced-card-header"
        class="pl-2 pr-3 small relative z-1"
      >
        <b-row>
          <b-col>Active Orders</b-col>
          <b-col cols="12" md="5">
            <b-dropdown class="float-right" variant="transparent p-0" right>
              <template slot="button-content">
                <i class="icon-clock"></i>
              </template>
              <b-dropdown-item
                v-for="timerange in timeranges"
                :key="timerange"
                @click="handleUpdate(timerange)"
                >{{ timerange }}</b-dropdown-item
              >
            </b-dropdown>
            <div class="mb-0 text-right pr-4">In the last: {{ timerange }}</div>
          </b-col></b-row
        >
      </b-card-header>
      <b-tooltip target="orderplaced-card-header" triggers="hover">
        Active Orders</b-tooltip
      >
      <b-card-body class="px-0 pt-0">
        <d-table
          refid="orders"
          :classdivtable="'gridtable'"
          :busy="busy"
          :icon="'fa fa-gavel'"
          :tools_enabled="''"
          :fields="options.fields"
          :badges="options.badges"
          :items="items"
          :showpages="false"
          @click="click"
          @load="loadChart"
        ></d-table>

        <!-- <b-table
          v-if="options.showtable"
          ref="logtable"
          id="logtable"
          striped
          sticky-header="300px"
          fixed
          small
          bordered
          :items="items"
          :fields="options.fields"
          class="gridtable my-0"
        >
          <template v-slot:cell()="row">
            <div
              v-if="
                options.badges &&
                options.badges.find((obj) => obj.key == row.field.key)
              "
            >
              <span
                v-html="
                  $helpers.badgeField(
                    row.item,
                    options.badges.find((obj) => obj.key == row.field.key),
                    options
                  )
                "
              ></span>
            </div>
            <div v-else>{{ row.value }}</div>
          </template>
        </b-table>
        <b-row class="excelsheetbuttons">
          <b-col>
            <b-button-group>
              <b-button
                :pressed="true"
                squared
                size="sm"
                variant="outline-secondary"
                id="orderplaced_log"
              >
                <i class="fa fa-list-ol"></i>
              </b-button>
              <b-tooltip target="orderplaced_log" triggers="hover"
                >Show list</b-tooltip
              >
            </b-button-group>
          </b-col> 
          <b-col class="text-right">
             <b-link
              id="orderplaced-start"
              :disabled="orderplaced.running"
              @click="action('start')"
              size="sm"
              class="mt-1 mr-2 text-primary"
            >
              <i class="fa fa-play"></i>
            </b-link>
            <b-tooltip target="orderplaced-start" triggers="hover"
              >Start service</b-tooltip
            >

            <b-link
              id="orderplaced-end"
              :disabled="!orderplaced.running"
              @click="action('stop')"
              size="sm"
              class="mt-1 mr-2 text-danger"
            >
              <i class="fa fa-stop"></i>
            </b-link>
            <b-tooltip target="orderplaced-end" triggers="hover"
              >Stop service</b-tooltip
            > 
            <b-link
              id="orderplaced-excel"
              class="mt-1 excel"
              @click="$helpers.outputExcel({ items, fields: options.fields })"
              title="Send to excel"
            >
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </b-link>
            <b-tooltip target="orderplaced-excel" triggers="hover"
              >Grid to excel</b-tooltip
            >
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
              <span class="small text-primary ml-2">Updating ...</span>
            </div>
            <span v-if="!busy" class="small text-primary"
              >Showing {{ options.items.length }} active order(s)</span
            >
            <br />
            <span v-if="!busy" class="small text-primary">{{
              options.actionmessage
            }}</span>
          </b-col>
        </b-row> -->
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "OrderPlaced",
  props: ["tile", "refresh"],
  data() {
    return {
      busy: false,
      timeout: false,
      name: "OrderPlaced",
      timerange: "90 days",
      timeranges: ["30 days", "60 days", "90 days", "180 days", "365 days"],
      items: [],
      options: {
        fields: [
          {
            key: "yourref",
            label: "Your Ref / PO",
            sortable: true,
            formatter: (value, key, item) => {
              let result = value;
              if (value.length >= 20) {
                result = value.slice(0, 17) + " ...";
              }
              return result;
            },
          },
          {
            key: "dateplaced",
            label: "Date Placed",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },

          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          {
            key: "progress",
            label: "Used Up %",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          {
            key: "value",
            label: "Value",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
            totalled: true,
            total: 0,
          },
          {
            key: "spent",
            label: "Spent",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
          },
          {
            key: "forecast",
            label: "Forecast",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
          },
          {
            key: "remaining",
            label: "Remaining",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
          },
        ],
        badges: [
          {
            key: "progress",
            type: "progressbar",
            class: "warning",
          },
        ],
      },
    };
  },
  async mounted() {
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    chartType() {
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Table";
      }
    },
  },
  methods: {
    async loadChart() {
      console.log("loadChart: orderplaced", this.timerange);

      this.busy = true;
      let from = null;
      switch (this.timerange) {
        case "30 days":
          from = moment().add(-30, "days").format("YYYY-MM-DD");
          break;
        case "60 days":
          from = moment().add(-60, "days").format("YYYY-MM-DD");
          break;
        case "90 days":
          from = moment().add(-90, "days").format("YYYY-MM-DD");
          break;
        case "180 days":
          from = moment().add(-180, "days").format("YYYY-MM-DD");
          break;
        case "365 days":
          from = moment().add(-365, "days").format("YYYY-MM-DD");
          break;
      }
      let variables = {
        dateplacedfrom: from,
        limit: this.limit,
        dateformat: "DD/MM/YYYY",
      };

      try {
        const response = await this.$apollo.query({
          query: gql`
            query orders(
              $id: String
              $dateplaced_at: [String]
              $slac: String
              $eventcode: String
              $agent: String
              $status: String
              $dateformat: String
              $limit: Int
            ) {
              orders(
                id: $id
                dateplaced_at: $dateplaced_at
                slac: $slac
                eventcode: $eventcode
                agent: $agent
                status: $status
                dateformat: $dateformat
                limit: $limit
              ) {
                id
                yourref
                slac
                reason
                dateplaced
                eventcode
                value
                spent
                forecast
                remaining
                status
                agent
              }
            }
          `,
          variables,
        });
        this.items = response.data.orders;

        for (var k = 0; k < this.items.length; k++) {
          if (this.items[k].value && this.items[k].spent) {
            this.items[k].progress = (
              (this.items[k].spent / this.items[k].value) *
              100
            ).toFixed(2);
          }
        }

      } catch (error) {
        console.log(error);
      }

      this.busy = false;
      await this.$emit("refreshed");
    },
    async handleUpdate(update) {
      console.log("handleUpdate", update);
      this.timerange = update;
      await this.loadChart();
    },
  },
};
</script>


<style>
</style>